import React from "react";
import { Mail } from "lucide-react";

/**
 * A small, gentle feedback line for any page bottom.
 * Placed below page content, above (or as) the outer page footer.
 */
export default function FeedbackFooter({ className = "" }) {
    return (
        <div
            className={`flex items-center justify-center gap-2 text-xs text-muted-foreground pt-10 pb-6 ${className}`}
            data-testid="feedback-footer"
        >
            <Mail className="w-3.5 h-3.5" strokeWidth={1.5} />
            <span>
                Have feedback?{" "}
                <a
                    href="mailto:query@cheerup-ai.com"
                    className="text-primary hover:underline"
                    data-testid="feedback-email-link"
                >
                    query@cheerup-ai.com
                </a>
            </span>
        </div>
    );
}
